/**
 * The one mapping from a saved invoicing address on the wire to the store slice.
 *
 * Extracted from `InvoicingAddressSection` for ISSUE-2963, so the section's
 * render-time highlight and `useDefaultInvoicingAddress`'s gate/body default are
 * literally the same value. Two copies could drift, and a drift here means the
 * address the client sees highlighted is not the one the order is billed to.
 */

import type { InvoicingAddressDTO } from 'dataQueries/invoicingAddresses.query'
import type { AddressDTO } from 'models/purchaseFlowRevamp'

export const dtoToSlice = (dto: InvoicingAddressDTO): AddressDTO => ({
  id: dto.id,
  label: dto.addressName,
  line1: dto.streetAndNumber,
  line2: dto.apartmentNumber,
  city: dto.city,
  postalCode: dto.postalCode,
  country: dto.country,
  vatNumber: dto.vatNumber,
})
